import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  variant = 'primary',
  fullWidth = false
}: CTAButtonProps) {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('purchase-section');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-lg px-8 py-4 text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-teal-600 hover:bg-teal-700 text-white border-2 border-transparent',
    secondary: 'bg-amber-500 hover:bg-amber-600 text-white border-2 border-transparent',
    outline: 'bg-transparent border-2 border-teal-600 text-teal-700 hover:bg-teal-50'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button onClick={scrollToPurchase} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} data-id="element-10">
      {children}
      <ArrowRight className="ml-2 h-5 w-5" data-id="element-11" />
    </button>;
}